import { IInventoryDeviceService } from '../models/inventory-device';

/**
 * Mirrors the backend rule (InventoryDevice.IsNextServiceComputed): the next service date is derived from
 * the latest service plus the interval only when both an interval and at least one service exist.
 * Otherwise the date is entered manually.
 */
export function isNextServiceComputed(services: IInventoryDeviceService[] | null | undefined, serviceInterval: number | null | undefined): boolean {
  return (services?.length ?? 0) > 0 && serviceInterval > 0;
}

/**
 * Preview of the value the backend will compute: latest execution date + interval months.
 * Returns null when the rule does not apply.
 */
export function computeNextService(services: IInventoryDeviceService[] | null | undefined, serviceInterval: number | null | undefined): Date | null {
  if (!isNextServiceComputed(services, serviceInterval)) {
    return null;
  }

  const latest = services
    .map(service => new Date(service.executionDate))
    .reduce((max, date) => (date > max ? date : max));

  return addMonthsClamped(latest, serviceInterval);
}

/**
 * Same semantics as .NET DateTime.AddMonths: the day is clamped to the last day of the target month
 * (31.01. + 1 month = 28.02.), unlike Date.setMonth which overflows into the following month.
 */
export function addMonthsClamped(date: Date, months: number): Date {
  const target = new Date(date.getFullYear(), date.getMonth() + months, 1);
  const lastDayOfTargetMonth = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  target.setDate(Math.min(date.getDate(), lastDayOfTargetMonth));
  return target;
}
